module.exports = __webpack_public_path__ + "media/packs/images/flags/MU-2bcaff42b2696bb40c9a7a98b5cfbe25.svg";